var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center"},_vm._l((_vm.count),function(index){return _c('div',{key:index,staticClass:"dotDivider"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }